require('dotenv').config()

export const config = {
  messageCollection: process.env.REACT_APP_MESSAGE_COLLECTION,
  host: {
    apiUrl: process.env.REACT_APP_MM_API_URL || 'http://localhost:3000',
  },
  mongo: {}
}